<div class="app-widget app-widget-blue" (click)="onClick()" >
    <div class="app-widget-left">
        <i class="fa-solid fa-inbox"></i>
    </div>
    <div class="app-widget-right">
        <div class="app-widget-content">
            <span class="app-widget-title">{{ translationManager.getTranslation('Понуде') }}</span>
            <span class="app-widget-subtitle">{{ translationManager.getTranslation('Непрочитане поруке') }}</span>
            <div class="app-widget-value">
                <div class="app-widget-spinner" *ngIf="loading">
                    <div class="spinner-border">
                    </div>
                </div>
                <span *ngIf="!loading">{{ value | appvalue}}</span>
            </div>
        </div>
    </div>
</div>
